import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const productColorsForOptionsSelector: Selector<ReduxState, SelectOption[]> = state =>
  state.productColors.productColorsForOptions
